/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Plum_Cat_RideInputs */

const en_deep_plum_cat_ride = /** @type {(inputs: Deep_Plum_Cat_RideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear filter`)
};

const de_deep_plum_cat_ride = /** @type {(inputs: Deep_Plum_Cat_RideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter löschen`)
};

/**
* | output |
* | --- |
* | "Clear filter" |
*
* @param {Deep_Plum_Cat_RideInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const deep_plum_cat_ride = /** @type {((inputs?: Deep_Plum_Cat_RideInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Plum_Cat_RideInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deep_plum_cat_ride(inputs)
	return de_deep_plum_cat_ride(inputs)
});